<template>
  <v-dialog
    :model-value="props.showRightDialog"
    :width="isMobileScreen ? '100%' : props.width"
    :max-width="isMobileScreen ? '100%' : props.width"
    :persistent="props.persistent"
    transition="slide-x-reverse-transition"
    :content-class="['right-side-dialog', { 'right-side-dialog--auto': autoSize }]"
    @click:outside="hiddenDialog"
    @keydown.esc="hiddenDialog"
  >
    <div class="right-dialog-container">
      <div v-if="showHeader" class="right-dialog-header">
        <v-icon class="icon-close" size="small" @click="hiddenDialog">$iconCloseDialog</v-icon>
        <h3
          v-if="props.dialogHeading"
          class="title-head"
          :class="{ 'title-head-red': props.dialogHeadingColor === 'red' }"
        >
          {{ props.dialogHeading }}
        </h3>
      </div>
      <slot />
      <div v-if="showFooter" class="right-dialog-actions pt-4 d-flex">
        <slot name="right-dialog-footer" />
      </div>
    </div>
  </v-dialog>
</template>

<script setup>
import { useDisplay } from "vuetify";
import { watch, onBeforeUnmount, computed } from "vue";

const emit = defineEmits(["update:showRightDialog"]);

const props = defineProps({
  showRightDialog: {
    type: Boolean,
    default: () => false,
  },
  width: {
    type: [String, Number],
    default: "33.643rem",
  },
  showHeader: {
    type: [Boolean],
    default: true,
  },
  showFooter: {
    type: [Boolean],
    default: true,
  },
  dialogHeading: {
    type: [String],
    default: "",
  },
  linkTo: {
    type: Array,
    default: () => {},
  },
  dialogHeadingColor: {
    type: String,
    default: "",
  },
  persistent: {
    type: Boolean,
    default: false,
  },
  autoSize: {
    type: Boolean,
    default: false,
  },
});

const { mobile } = useDisplay();

function hiddenDialog() {
  emit("update:showRightDialog", false);
}
const isMobileScreen = computed(() => {
  return mobile.value;
});

watch(
  () => props.showRightDialog,
  (value) => {
    const scrollbarWidth = window.innerWidth - window.document.body.clientWidth;
    const htmlEl = window.document.querySelector("html");
    if (value) {
      htmlEl.style.overflow = "hidden";
      htmlEl.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      htmlEl.style.overflow = "";
      htmlEl.style.paddingRight = "";
    }
  },
);

onBeforeUnmount(() => {
  const htmlEl = window.document.querySelector("html");
  htmlEl.style.overflow = "";
  htmlEl.style.paddingRight = "";
});
</script>

<style scoped lang="scss">
@use "./RightSideDialog.scss";
</style>
